module.exports = __webpack_public_path__ + "static/img/business15.468fec3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business15.jpg
// module id = Mr88
// module chunks = 9